import React from "react";
import PaymentTable from "./PaymentTable";
import { Box } from "@mui/material";
import { PaymentMethodsTypes } from "types";

const PaymentManagementData = () => {
  return (
    // <Box bgcolor={{ xs: "#F3F3F3", md: "#F3F3F3" }}>
    <PaymentTable />
    // </Box>
  );
};

export default PaymentManagementData;
